<template>
  <div class="container-fixed" role="progressbar" aria-valuemin="1" :aria-valuenow="activeIndex + 1" :aria-valuemax="stepCnt" :aria-valuetext="valueText">
    <div class="row steps">
      <div v-for="(step, index) in steps" :key="step.name" :class="stepClass(index)"
        ><small>{{ index + 1 }}.</small> {{ $t(step.name) }}</div
      >
    </div>
    <div class="progress-bar"><div class="status" :style="{ width: percent + '%' }"></div></div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Progress',

  props: {
    steps: {
      type: Array,
      required: true,
    },

    active: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapGetters('system', ['isTelekom']),

    percent() {
      return (100 / this.stepCnt) * (this.activeIndex + 1);
    },

    stepCnt() {
      return this.steps.length;
    },

    valueText() {
      return this.activeIndex + 1 + '. ' + this.$to(`${this.steps[this.activeIndex].name}`);
    },

    activeIndex() {
      return this.steps.findIndex(s => s.name === this.active);
    },
  },

  methods: {
    stepClass(step) {
      const arr = ['step text-center'];
      const width = 12 / this.steps.length;
      arr.push(`col-l-${width}`);
      arr.push(`col-m-${width}`);

      if (step === this.activeIndex) {
        arr.push('active');
        arr.push('h4');
        arr.push('col-s-12');
        arr.push('col-xs-12');
      } else if (step < this.activeIndex) {
        arr.push('done');
        arr.push('hidden-s');
        arr.push('hidden-xs');
      } else {
        arr.push('inactive');
        arr.push('hidden-s');
        arr.push('hidden-xs');
      }

      return arr;
    },
  },
};
</script>

<style scoped>
.progress-bar {
  height: 3px;
  margin-right: -12px;
  margin-left: -12px;
  background-color: #e5e5e5;
}

@media screen and (min-width: 1024px) {
  .progress-bar {
    margin-right: 12px;
  }
}
.progress-bar .status {
  display: block;
  height: 3px;
  content: ' ';
  background-color: #e20074;
}
.steps .active {
  padding-bottom: 0;
  font-weight: 600;
}
.steps .inactive {
  margin-top: 22px;
  line-height: 16px;
  color: #757575;
}
.steps .done {
  margin-top: 22px;
  font-weight: 100;
  line-height: 16px;
}
</style>
